(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('prospective-patient', {
            parent: 'entity',
            url: '/prospective-patient?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.prospectivePatient.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/prospective-patient/prospective-patients.html',
                    controller: 'ProspectivePatientController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('prospectivePatient');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('prospective-patient-detail', {
            parent: 'entity',
            url: '/prospective-patient/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.prospectivePatient.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/prospective-patient/prospective-patient-detail.html',
                    controller: 'ProspectivePatientDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('prospectivePatient');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ProspectivePatient', function($stateParams, ProspectivePatient) {
                    return ProspectivePatient.get({id : $stateParams.id});
                }]
            }
        })
        .state('prospective-patient.new', {
            parent: 'prospective-patient',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/prospective-patient/prospective-patient-dialog.html',
                    controller: 'ProspectivePatientDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                firstName: null,
                                lastName: null,
                                phone: null,
                                email: null,
                                mobile: null,
                                birthYear: null,
                                countryName: null,
                                regionName: null,
                                prefectureName: null,
                                cityName: null,
                                postalCode: null,
                                address: null,
                                addressNum: null,
                                isWrongPhone: null,
                                isWrongContact: null,
                                amka: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('prospective-patient', null, { reload: true });
                }, function() {
                    $state.go('prospective-patient');
                });
            }]
        })
        .state('prospective-patient.edit', {
            parent: 'prospective-patient',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/prospective-patient/prospective-patient-dialog.html',
                    controller: 'ProspectivePatientDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProspectivePatient', function(ProspectivePatient) {
                            return ProspectivePatient.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('prospective-patient', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('prospective-patient.delete', {
            parent: 'prospective-patient',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/prospective-patient/prospective-patient-delete-dialog.html',
                    controller: 'ProspectivePatientDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ProspectivePatient', function(ProspectivePatient) {
                            return ProspectivePatient.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('prospective-patient', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
